import { render, staticRenderFns } from "./ExportProspects.vue?vue&type=template&id=13696c0a"
import script from "./ExportProspects.vue?vue&type=script&lang=js"
export * from "./ExportProspects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports